import { render, staticRenderFns } from "./UserAPI.vue?vue&type=template&id=ac5c9120"
import script from "./UserAPI.vue?vue&type=script&lang=js"
export * from "./UserAPI.vue?vue&type=script&lang=js"
import style0 from "./UserAPI.vue?vue&type=style&index=0&id=ac5c9120&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports